module.exports = __webpack_public_path__ + "media/assets/img/slider/05-f45463a139721ed559d645d3c57967f8.jpg";